// User-friendly error message mappings
export const getErrorMessage = (error: any): { title: string; description: string } => {
  const errorMessage = error?.message?.toLowerCase() || '';
  
  // Authentication errors
  if (errorMessage.includes('invalid login credentials') || errorMessage.includes('invalid email or password')) {
    return {
      title: "Login Failed",
      description: "The email or password you entered is incorrect. Please try again."
    };
  }
  
  if (errorMessage.includes('email not confirmed')) {
    return {
      title: "Email Not Verified",
      description: "Please check your inbox and verify your email address before signing in."
    };
  }
  
  if (errorMessage.includes('user already registered')) {
    return {
      title: "Account Already Exists",
      description: "An account with this email already exists. Please sign in instead."
    };
  }
  
  if (errorMessage.includes('password should be at least')) {
    return {
      title: "Weak Password",
      description: "Your password must be at least 6 characters long."
    };
  }
  
  if (errorMessage.includes('invalid email')) {
    return {
      title: "Invalid Email",
      description: "Please enter a valid email address."
    };
  }
  
  // Network errors
  if (errorMessage.includes('network') || errorMessage.includes('fetch')) {
    return {
      title: "Connection Error",
      description: "Unable to connect to the server. Please check your internet connection."
    };
  }
  
  // Rate limiting
  if (errorMessage.includes('rate limit') || errorMessage.includes('too many requests')) {
    return {
      title: "Too Many Attempts",
      description: "Please wait a moment before trying again."
    };
  }
  
  // Meeting errors
  if (errorMessage.includes('meeting not found')) {
    return {
      title: "Meeting Not Found",
      description: "The meeting code you entered doesn't exist or has ended."
    };
  }
  
  // WebRTC/Media errors
  if (errorMessage.includes('permission') || errorMessage.includes('notallowederror')) {
    return {
      title: "Permission Denied",
      description: "Please allow access to your camera and microphone in browser settings."
    };
  }

  if (errorMessage.includes('notfounderror') || errorMessage.includes('device not found')) {
    return {
      title: "Device Not Found",
      description: "No camera or microphone detected. Please check your device connections."
    };
  }

  if (errorMessage.includes('notreadableerror')) {
    return {
      title: "Device Busy",
      description: "Your camera or microphone is being used by another application."
    };
  }

  // Timeout errors
  if (errorMessage.includes('timeout') || errorMessage.includes('timed out')) {
    return {
      title: "Request Timeout",
      description: "The request took too long. Please try again."
    };
  }

  // Session/Auth errors
  if (errorMessage.includes('session') || errorMessage.includes('unauthorized')) {
    return {
      title: "Session Expired",
      description: "Your session has expired. Please sign in again."
    };
  }

  // Default error
  return {
    title: "Something Went Wrong",
    description: error?.message || "An unexpected error occurred. Please try again."
  };
};
